const docFields = {
  fields: "שדות",
  formFields: "שדות טופס",
  addField: "הוסף שדה",
  noFields: "אין שדות — הוסף שדות שחותמים ימלאו",
  label: "תווית",
  placeholder: "טקסט ברירת מחדל",
  options: "אפשרויות",
  option: "אפשרות",
  addOption: "הוסף אפשרות",
  required: "שדה חובה",
} as const;
export default docFields;
